export const PATIENT_ROUTES = {
    restorePassword: "/restore-password",
    passwordExpiredLink: "/password-expired-link",
    resendPasswordLink: "/resend-password-link"
};

export const FALLBACK_ROUTE = "/appointments";
